import React from 'react';
import { Main } from './components';

const EligibleStorage = () => <Main />;

export default EligibleStorage;
